import { createSelector } from 'reselect';
import { IRootState } from '../store';
import {
  AvailablePlan,
  AvailablePlanInterval,
  PaymentsState,
} from '../reducers/payments';

export const selectPayments = (state: IRootState): PaymentsState =>
  state.payments;

export const selectAvailablePlans = createSelector(
  selectPayments,
  (payments) => payments.availablePlans
);

const matchTargetPlan = (targetPlanType: AvailablePlanInterval) => (
  plans: AvailablePlan[]
) => plans.find((plan) => plan.interval === targetPlanType);

export const selectMonthlyPlan = createSelector(
  selectAvailablePlans,
  matchTargetPlan('month')
);

export const selectYearlyPlan = createSelector(
  selectAvailablePlans,
  matchTargetPlan('year')
);

export const selectAvailableCards = createSelector(
  selectPayments,
  (payments: PaymentsState) => payments.availableCards
);

export const selectReferralInfo = createSelector(
  selectPayments,
  (payments: PaymentsState) => payments.referralInfo
);
